// src/services/moduloConteudoServices.js
import { useApi } from './api';
import { URLS } from '../constants/urls';

export function useModuloConteudoService() {
  const { authenticatedFetch, authenticatedFormFetch } = useApi();

  /**
   * criarConteudo
   * Espera SEMPRE um FormData:
   *  - idSecao
   *  - tipo
   *  - ordem
   *  - campos textuais
   *  - e, se houver, arquivos de imagem/pdf
   */
  const criarConteudo = async (formData) => {
    const response = await authenticatedFormFetch(
      URLS.CREATE_MODULO_CONTEUDO,
      formData
    );
    return response.json();
  };

  /**
   * atualizarConteudo
   * - Se receber um FormData  -> envia como multipart/form-data
   * - Se receber um objeto JS -> envia como JSON (application/json)
   */
  const atualizarConteudo = async (payloadOrFormData) => {
    // Com arquivo novo (imagem/pdf) -> FormData
    if (payloadOrFormData instanceof FormData) {
      const response = await authenticatedFormFetch(
        URLS.UPDATE_MODULO_CONTEUDO,
        payloadOrFormData
      );
      return response.json();
    }

    // Sem arquivo novo -> JSON
    const response = await authenticatedFetch(URLS.UPDATE_MODULO_CONTEUDO, {
      method: 'POST',
      body: JSON.stringify(payloadOrFormData),
    });
    return response.json();
  };

  const deletarConteudo = async (id) => {
    const response = await authenticatedFetch(URLS.DELETE_MODULO_CONTEUDO, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const listarConteudos = async () => {
    const response = await authenticatedFetch(URLS.READ_MODULO_CONTEUDO, {
      method: 'POST',
      body: JSON.stringify({}),
    });

    return response.json();
  };

  const obterConteudoPorId = async (id) => {
    const response = await authenticatedFetch(URLS.READ_MODULO_CONTEUDO_BY_ID, {
      method: 'POST',
      body: JSON.stringify({ id }),
    });

    return response.json();
  };

  const listarConteudosPorSecao = async (idSecao) => {
    const response = await authenticatedFetch(
      URLS.READ_MODULO_CONTEUDO_BY_SECAO,
      {
        method: 'POST',
        body: JSON.stringify({ idSecao }),
      }
    );

    return response.json();
  };

  return {
    criarConteudo,
    atualizarConteudo,
    deletarConteudo,
    listarConteudos,
    obterConteudoPorId,
    listarConteudosPorSecao,
  };
}